import React from 'react';

import { PCNLRiskAssessmentItem } from '../../../../utils/models';
import { getPCNLAnomalyStyle } from '../../../../utils/utilities';

import classNames from './style.module.scss';

interface Props {
    data: PCNLRiskAssessmentItem[];
}

const PCNLRiskAssessmentTable: React.FC<Props> = ({ data }) => {
    return ( 
        <div className="p-1 table-responsive">
            <table className={classNames.table}>
                <thead>
                    <tr>
                        <th rowSpan={2}>Structural Member</th>
                        <th rowSpan={2}>Quantity</th>
                        <th colSpan={2}>Hazard</th>
                        <th colSpan={3}>Initial Risk</th>
                        <th rowSpan={2}>Controls Required</th>
                        <th colSpan={3}>Residual Risk</th>
                        <th rowSpan={2}>Ref</th>
                    </tr>
                    <tr className={classNames.tableSubheader}>
                        <th>Hazard Description & Effect</th>
                        <th>People, Property at Risk</th>
                        <th>Hazard Consequence</th>
                        <th>Chance of Occurrence</th>
                        <th>Risk Rating</th>
                        <th>Controlled Hazard Consequence</th>
                        <th>Controlled Chance of Occurrence</th>
                        <th>Residual</th>
                    </tr>
                </thead>
                <tbody>
                    {data.map((dataItem) => (
                        <tr key={dataItem.structuralMember}>
                            <td>{dataItem.structuralMember}</td>
                            <td>{dataItem.quantity ?? 'N/A'}</td>
                            <td>{dataItem.hazardDescription}</td>
                            <td>{dataItem.peopleAtRisk ? dataItem.peopleAtRisk.map((risk) => risk.label).join(', ') : 'N/A'}</td>
                            <td>{dataItem.hazardConsequence}</td>
                            <td>{dataItem.chanceOfOccurrence}</td>
                            <td style={getPCNLAnomalyStyle({ riskFactor: dataItem.riskRating })}>{dataItem.riskRating}</td>
                            <td>{dataItem.controlsRequired}</td>
                            <td>{dataItem.controlledHazardConsequence}</td>
                            <td>{dataItem.controlledChanceOfOccurrence}</td>
                            <td style={getPCNLAnomalyStyle({ riskFactor: dataItem.residual })}>{dataItem.residual}</td>
                            <td>{dataItem.ref}</td>
                        </tr>
                    ))} 
                </tbody>
            </table>
        </div>
     );
}
 
export default PCNLRiskAssessmentTable;